<template>
  <tr :class="[border ? '' : 'no-border-top no-border-bottom']">
    <!-- Site -->
    <td>
      <device-site
        v-if="showSite"
        :device="device"
      />
    </td>
    <!-- Decodertype -->
    <td>
      <device-decodertype :device="device" />
    </td>
    <!-- Description -->
    <td style="position: relative">
      <device-description :device="device" />
      <img
        v-if="device.is_new"
        :src="$store.state.common.newBadgeURL"
        class="newbadge"
        width="42"
        :title="isNewTooltip"
      >
    </td>
    <!-- Addresses (MAC/IP) -->
    <td>
      <device-addresses :device="device" />
    </td>
    <!-- Status (online, last-online, tv-content-up-to-date) -->
    <td>
      <device-status :device="device" />
    </td>
    <!-- Last-online -->
    <td>
      <device-last-online :device="device" />
    </td>
    <!-- Actions -->
    <td>
      <device-actions
        :device="device"
        @renamed="$emit('renamed')"
      />
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs';

import DeviceActions from '@/components/Device/DeviceActions';
import DeviceAddresses from '@/components/Device/DeviceAddresses';
import DeviceDecodertype from '@/components/Device/DeviceDecodertype';
import DeviceDescription from '@/components/Device/DeviceDescription';
import DeviceLastOnline from '@/components/Device/DeviceLastOnline';
import DeviceSite from '@/components/Device/DeviceSite';
import DeviceStatus from '@/components/Device/DeviceStatus';

export default {
  components: {
    DeviceActions,
    DeviceAddresses,
    DeviceDecodertype,
    DeviceDescription,
    DeviceLastOnline,
    DeviceSite,
    DeviceStatus,
  },
  props: {
    /** It's basically a serialized Radio-/TVDecoder.
     *
     * Does have extra attributes though due to augmentation to e.g.
     * improve sortability within the v-data-table.
     */
    device: {
      type: Object,
      required: true,
    },
    isSlave: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showSite: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isNewTooltip() {
      if (!this.device.is_new) {
        return '';
      }
      return (
        this.$t('playerCreatedAt') +
        ' ' +
        dayjs(this.device.created_at).format('DD.MM.YYYY')
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceTableRow.vue